import React, { useEffect, useState } from 'react';
import { listThreads } from './api';
import { COPY } from './copy';
import MessageList from './MessageList';

// Read-only archive of the Specialist→GP RAI thread on a CLOSED issue
// (story sc-28426). The thread auto-closes with reason :report_submitted when
// the specialist submits the consult; both the specialist and the GP need to
// see what was asked and (if applicable) what was sent back.
const ClosedSpecialistToGpArchive = ({ issue }) => {
  const [thread, setThread] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    listThreads(issue.id)
      .then((data) => {
        if (cancelled) return;
        const t = (data || []).find((x) => x.direction === 'specialist_to_gp');
        setThread(t || null);
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [issue.id]);

  if (loading || !thread || thread.messages.length === 0) return null;

  const gpResponded = thread.messages.some((m) => m.author?.role === 'gp');
  const bannerHex = gpResponded ? COPY.hex.closedBlue : COPY.hex.alertRed;
  const bannerText = gpResponded
    ? COPY.sections.additionalInformationProvided
    : COPY.sections.additionalInformationRequested;

  return (
    <div className="bg-white rounded shadow mb-4">
      <div
        className="font-semibold uppercase text-sm text-white px-3 py-2 rounded-t"
        style={{ backgroundColor: bannerHex }}
      >
        {bannerText}
      </div>
      <div className="border border-t-0 border-gray-200 rounded-b p-3 bg-slate-50">
        <MessageList messages={thread.messages} />
      </div>
    </div>
  );
};

export default ClosedSpecialistToGpArchive;
